<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M51.727 12.273a1.5 1.5 0 010 2.121L16.955 49.167H40a1.5 1.5 0 110 3H13.333a1.5 1.5 0 01-1.5-1.5V24a1.5 1.5 0 113 0v23.045l34.773-34.772a1.5 1.5 0 012.121 0z"/></svg>